import { DataTable, Column, Skeleton } from 'primereact';
import {getLink} from "../../../Commons/Scripts/Utils/link";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {RadioButtonField} from "../../../Commons/Scripts/Componentes/RadioButtonField";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {Message, MessageProvider, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import {formatear2Decimales} from "../../../Commons/Scripts/Utils/formatear";
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {ImpuestoReporteService} from "../Services/impuesto-reporte-service";
import React,{useState,useEffect} from 'react';
const origin = window.location.origin;

function TablaReporte606({ reporte, loading }) {
  const columnas = [
    {
      header: "Id",
      field: "Id",
      key: "Id",
      crearLink: (item) => getLink(item.FoG, item.Id),
      alignRight: true,
      noMinWith: true,
    },
    { header: "FoG", field: "FoG", key: "FoG", crearLink: (item) => getLink(item.FoG, item.Id) },
    { header: "Tipo", field: "Tipo", key: "Tipo" },
    { header: "RNC o Cedula", field: "RNCoCedula", key: "RNCoCedula", alignRight: true },
    { header: "Suplidor", field: "RazonSocial", key: "RazonSocial" },
    { header: "NCF", field: "NCF", key: "NCF", crearLink: (item) => getLink(item.FoG, item.Id) },
    { header: "NCF Modificado", field: "NCFModificado", key: "NCFModificado" },
    { header: "Fecha Comprobante", field: "FechaComprobante", key: "FechaComprobante", alignRight: true },
    { header: "Fecha Pago", field: "FechaPago", key: "FechaPago", alignRight: true },
    { header: "Monto Servicios", field: "MontoServicios", key: "MontoServicios", esNumerico: true },
    { header: "Monto Bienes", field: "MontoBienes", key: "MontoBienes", esNumerico: true },
    { header: "ITBIS Facturado", field: "ItbisFacturado", key: "ItbisFacturado", esNumerico: true },
    { header: "ITBIS Retenido", field: "ItbisRetenido", key: "ItbisRetenido", esNumerico: true },
    { header: "Retencion Renta", field: "RetencionRenta", key: "RetencionRenta", esNumerico: true },
    { header: "ITBIS al Costo", field: "ItbisLLevadoAlCosto", key: "ItbisLLevadoAlCosto", esNumerico: true },
    { header: "ITBIS por adelantar", field: "ItbisPorAdelantar", key: "ItbisPorAdelantar", esNumerico: true },
    {
      header: "ITBIS Percibido en Compras",
      field: "ItbisPercibidoEnCompras",
      key: "ItbisPercibidoEnCompras",
      esNumerico: true,
    },
    {
      header: "Impuesto Selectivo al Consumo",
      field: "ImpuestoSelectivoAlConsumo",
      key: "ImpuestoSelectivoAlConsumo",
      esNumerico: true,
    },
    { header: "Tipo Retencion ISR", field: "TipoRetencionISR", key: "TipoRetencionISR" },
    { header: "Otros Impuestos", field: "OtrosImpuestos", key: "OtrosImpuestos", esNumerico: true },
    { header: "Propina", field: "Propina", key: "Propina", esNumerico: true },
    { header: "Forma de Pago", field: "FormaDePago", key: "FormaDePago" },
  ];

  if (loading) {
    return (
      <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
        <Column body={<Skeleton style={{ height: "40px" }} />} />
      </DataTable>
    );
  }

  return (
    <DataTable id="grid" value={reporte} emptyMessage="No se han encontrado resultados" sortMode="multiple">
      {columnas.map(
        ({ key, field, header, esNumerico = false, alignRight = false, noMinWith = false, crearLink = null }) => {
          const style = {
            minWidth: noMinWith ? undefined : "7rem",
            textAlign: esNumerico ? "right" : alignRight ? "right" : undefined,
          };

          return (
            <Column
              field={field}
              style={style}
              headerClassName={esNumerico ? "alinear-derecha" : alignRight ? "alinear-derecha" : undefined}
              key={key}
              body={(item) => {
                if (crearLink) {
                  return (
                    <a className="link" href={crearLink(item)} target="_target">
                      {item[field]}
                    </a>
                  );
                }
                if (esNumerico) {
                  return <span>{formatear2Decimales(item[field])}</span>;
                }
                return <span>{item[field]}</span>;
              }}
              header={header}
              footer={() => {
                if (!esNumerico) {
                  return null;
                }

                const total = reporte?.reduce((acc, item) => acc + item[field], 0);
                return <span>{formatear2Decimales(total)}</span>;
              }}
              sortable
            ></Column>
          );
        }
      )}
    </DataTable>
  );
}

function TablaReporte606Resumen({ resumen, loading }) {
  if (loading) {
    return null;
  }

  return (
    <table className="table">
      <thead>
        <tr>
          <th className="th">Periodo</th>
          <td className="td">{resumen?.Periodo}</td>
          <th className="th">Total Monto Facturado</th>
          <th className="th">Itbis Facturado</th>
          <th className="th">Itbis Retenido</th>
          <th className="th">Retencion Renta</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="td">Cantidad de Registos</td>
          <td className="td">{resumen?.CantidadRegistros}</td>
          <td className="td">{formatear2Decimales(resumen?.TotalMontoFacturado)}</td>
          <td className="td">{formatear2Decimales(resumen?.TotalItbisFacturado)}</td>
          <td className="td">{formatear2Decimales(resumen?.TotalItbisRetenido)}</td>
          <td className="td">{formatear2Decimales(resumen?.TotalRetencionRenta)}</td>
        </tr>
      </tbody>
    </table>
  );
}

function Formulario({ loading, anios, meses, onSubmit, valorInicial = {}, onChange, where }) {

  const form = useForm(valorInicial);

  const [mostrarMeses, setMostrarMeses] = useState(false);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.REPORTE_606, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.REPORTE_606, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.REPORTE_606, "CSV");

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  const handleChange = (values) => {
    if (values.tipo === "mes") {
      setMostrarMeses(true);
    } else {
      setMostrarMeses(false);
    }

    onChange(values);
  };

  return (
    <SimpleForm formulario={form} onChange={handleChange}>
      <div className="row">
        <div className="label">Tipo</div>
        <div className="container-rb">
          <RadioButtonField name="tipo" label="Por año" value="anio" />
          <RadioButtonField name="tipo" label="Por mes" value="mes" />
        </div>
      </div>
      <div className="row">
        <SelectField
          name="anio"
          opciones={anios || []}
          placeholder="Todos"
          label="Año"
          isLoading={loading}
          width="100px"
        />
        {mostrarMeses && (
          <SelectField
            name="mes"
            opciones={meses || []}
            label="Mes"
            placeholder="Todos"
            isRow
            isLoading={loading}
            width="125px"
          />
        )}
      </div>
      <div className="container-btn">
        <Button2 texto="Buscar" icono="buscar" onClick={handleSubmit} />
        <Button2 texto="PDF" icono="imprimir" loading={loadingPdf} onClick={() => handlePdf(where)} />
        <Button2 texto="Excel" icono="excel" loading={loadingExcel} onClick={() => handleExcel(where)} />
        <Button2 texto="CSV" icono="excel" loading={loadingCsv} onClick={() => handleCsv(where)} />
      </div>
    </SimpleForm>
  );
}

export function Reporte606() {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [loadingDatos, setLoadingDatos] = useState(false);
  const [anios, setAnios] = useState();
  const [meses, setMeses] = useState();

  const [loading, setLoading] = useState(false);
  const [reporte, setReporte] = useState();
  const [where, setWhere] = useState({ anio: new Date().getFullYear(), mes: 1 });
  const [resumen, setResumen] = useState();

  useEffect(() => {
    setLoading(true);
    clearMessages();

    ImpuestoReporteService.consultarReporte606(where)
      .then((res) => {
        setReporte(res?.Resultados);
        setResumen(res?.Resumen);
      })
      .catch((err) => {
        handleException(err);
      })

      .finally(() => {
        setLoading(false);
      });
  }, [where]);

  useEffect(() => {
    setLoadingDatos(true);
    clearMessages();

    Promise.all([ImpuestoReporteService.consultarAnios(), ImpuestoReporteService.consultarMeses()])
      .then((res) => {
        const anios = res[0]?.map((anio) => {
          return {
            value: anio.id,
            label: anio.text,
          };
        });
        const meses = res[1]?.map((mes) => {
          return {
            value: mes.id,
            label: mes.text,
          };
        });

        setAnios(anios);
        setMeses(meses);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoadingDatos(false);
      });
  }, []);

  return (
    <div>
      <Message messages={messages} type={typeMessages} />
      <Formulario
        anios={anios}
        meses={meses}
        loading={loadingDatos}
        onSubmit={(formulario) => {
          const where = {
            anio: formulario.anio?.value != "-1" ? formulario.anio?.value : null,
            mes: formulario.mes?.value != "-1" && formulario.tipo == "mes" ? formulario.mes?.value : null,
          };
          setWhere(where);
        }}
        valorInicial={{
          tipo: "mes",
          anio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
          mes: { value: 1, label: "Enero" },
        }}
        onChange={(formulario) => {}}
        where={where}
      />
      <TablaReporte606Resumen resumen={resumen} loading={loading} />
      <TablaReporte606 reporte={reporte} loading={loading} />
    </div>
  );
}
